import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage, languages } from '../../context/LanguageContext';
import { Check, ArrowLeft, Globe } from 'lucide-react';
import { toast } from 'sonner';

const LanguageSettings = () => {
  const navigate = useNavigate();
  const { language, changeLanguage, t } = useLanguage();

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    toast.success(t('languageChanged'));
  };

  return (
    <div data-testid="language-settings-page" className="max-w-2xl mx-auto">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate('/gposp/settings')}
          className="p-2 hover:bg-slate-100 rounded-lg"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-slate-800">{t('languageSettings')}</h1>
          <p className="text-slate-500">{t('selectLanguage')}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex items-center gap-3">
          <Globe className="w-5 h-5 text-violet-600" />
          <span className="font-medium text-slate-700">{t('selectLanguage')}</span>
        </div>

        <div className="divide-y divide-slate-100">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center justify-between p-4 hover:bg-slate-50 transition-colors ${
                language === lang.code ? 'bg-violet-50' : ''
              }`}
              data-testid={`lang-${lang.code}`}
            >
              <div className="flex items-center gap-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold ${
                  language === lang.code 
                    ? 'bg-violet-600 text-white' 
                    : 'bg-slate-100 text-slate-600'
                }`}>
                  {lang.code.toUpperCase()}
                </div>
                <div className="text-left">
                  <p className={`font-medium ${language === lang.code ? 'text-violet-700' : 'text-slate-800'}`}>
                    {lang.nativeName}
                  </p>
                  <p className="text-sm text-slate-500">{lang.name}</p>
                </div>
              </div>
              {language === lang.code && (
                <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center">
                  <Check className="w-5 h-5 text-white" />
                </div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Preview */}
      <div className="mt-6 bg-white rounded-xl border border-slate-200 p-4">
        <h3 className="font-medium text-slate-700 mb-3">Preview</h3>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('save')}</span>
          </div>
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('cancel')}</span>
          </div>
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('products')}</span>
          </div>
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('billing')}</span>
          </div>
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('customer')}</span>
          </div>
          <div className="p-3 bg-slate-50 rounded-lg">
            <span className="text-slate-500">{t('payment')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSettings;
